var app = angular.module("leonardo");

var RevisionRequiredDialog = function ($scope, UserService, $filter, PermissionService, AccountUserService, AuthDataService, AccountService) {
  $scope.current_step = $scope.ngDialogData.current_step;
  $scope.reviewed_steps = $scope.ngDialogData.reviewed_steps;
  $scope.isShowFallback = $scope.ngDialogData.is_showfallback;

  $scope.getAccountUserAccount = function () {
    var result = [];
    var report_to_account_Id = AuthDataService.authData.accountUser.report_to;
    var report_to_accountuser = AccountUserService.getAccountUser(report_to_account_Id); 
    AccountService.get(report_to_accountuser.account).then(function(data) {
      $scope.accountObj = data;
      angular.forEach(data.owners, function (owner) {
        if (owner.id == report_to_account_Id) {
          var userobj= {id: report_to_account_Id, name: owner.user.first_name + " " + owner.user.last_name};
          result.push(userobj);
        }
      });
      $scope.ngDialogData.fallback_approvers = result;
    });
  };

  if($scope.isShowFallback) {
    $scope.getAccountUserAccount();
  }
  
  $scope.userService = UserService;
  $scope.permissionService = PermissionService;

  $scope.request_options = [
    {id: 'return_submitter', name: $filter('translate')('Return to Submitter')}
  ];

  if ($scope.current_step.index > 1) {
    $scope.request_options.push({id: 'previous_step', name: $filter('translate')('Previous Step Approvers')});
  }

  $scope.step_approvers_options = [];
  $scope.data = {
    request_type: 'return_submitter'
  };

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) return;
    $scope.confirm($scope.data);
  };

  $scope.initLoading = function () {
    let reviewed_steps_sequenced = $filter('filter')($scope.reviewed_steps, { approval_sequence: $scope.current_step.approval_sequence });
    angular.forEach(reviewed_steps_sequenced, function (reviewed_step) {
      let user_approvers = reviewed_step.user_approvers ? reviewed_step.user_approvers.map(user => user.email) : [];
      $scope.step_approvers_options.push({
        id: reviewed_step.index,
        name: `${reviewed_step.user_approvers.length >= 1 ? `${reviewed_step.index} - ${user_approvers.join(', ')}` : `${reviewed_step.index}`}`
      });
    });
  };

  $scope.initLoading();
};

app.controller('RevisionRequiredDialog', ['$scope', 'UserService', '$filter', 'PermissionService', 'AccountUserService', 'AuthDataService', 'AccountService', RevisionRequiredDialog]);
